"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateRowKeyFromRowIdxAndPageNo = void 0;
const base26_1 = __importDefault(require("base26"));
function generateRowKeyFromRowIdxAndPageNo(rowIdx) {
    if (rowIdx === undefined || rowIdx === null)
        return '---';
    try {
        return base26_1.default.to(rowIdx).toUpperCase();
    }
    catch (_a) { }
    return '---';
}
exports.generateRowKeyFromRowIdxAndPageNo = generateRowKeyFromRowIdxAndPageNo;
exports.default = generateRowKeyFromRowIdxAndPageNo;
